import axios from "axios";
import api from "../sharedInterceptors";
let checkAuthPromise = null;

api.defaults.baseURL = process.env.REACT_APP_AUTH_BASEURL_V1;
class AuthAPI {
  async postLogin(email, password, captchaToken) {
    return await axios.post(
      `${process.env.REACT_APP_AUTH_BASEURL_V1}/auth/login/`,
      {
        email: email,
        password,
        captcha_token: captchaToken,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
  }
  async postRegister(formData) {
    return await axios.post(
      `${process.env.REACT_APP_AUTH_BASEURL_V1}/auth/register/`,
      formData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
  }
  async updateProfileAPI(formData) {
    return await api.put(
      `${process.env.REACT_APP_AUTH_BASEURL_V1}/auth/me/update/`,
      formData,
      {
        headers: {
          "Content-Type": "application/json", //This content type indicates that the body of the request contains JSON data.
        },
      },
    );
  }
  async updatePasswordAPI(password, newPassword, id) {
    return await api.put(
      `${process.env.REACT_APP_AUTH_BASEURL_V1}/auth/me/password/update/`,
      { old_pass: password, new_pass: newPassword, id: id },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
  }
  async logoutAPI() {
    api.post(
      `${process.env.REACT_APP_AUTH_BASEURL_V1}/auth/logout/`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
  }
  async getUserDataAPI() {
    return await api.get(`${process.env.REACT_APP_AUTH_BASEURL_V1}/auth/me/`);
  }
  async checkAuth() {
    // If a check is already in flight, return the same promise to everyone
    if (checkAuthPromise) {
      return checkAuthPromise;
    }
    // Otherwise, create the promise and cache it
    checkAuthPromise = api
      .get(`${process.env.REACT_APP_AUTH_BASEURL_V1}/auth/check/`)
      .finally(() => {
        // Clear the cache as soon as it resolves or rejects
        // so the NEXT call can fire a fresh request if needed
        checkAuthPromise = null;
      });

    return checkAuthPromise;
  }
  async postAcceptMentions(email, password) {
    return await axios.post(
      `${process.env.REACT_APP_AUTH_BASEURL_V1}/auth/complete-first-login/`,
      {
        email: email,
        password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
  }
}

export default AuthAPI;
